import { useAuthContext } from '../auth/AuthProviderV2';
import { hasRoleAccess } from '../auth/RestrictAccess';

export default function useRoleAccess(role) {
  const { user } = useAuthContext();
  return hasRoleAccess(role, user);
}
